module.exports = __webpack_public_path__ + "static/media/undraw_code_thinking_re_gka2.d3b07988.svg";